var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#00C495"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9728 21.6103C22.8625 21.6103 24.3988 20.0613 24.3988 18.1589C24.3988 16.2566 22.8625 14.7075 20.9728 14.7075C19.0831 14.7075 17.5469 16.2566 17.5469 18.1589C17.5469 20.0613 19.0831 21.6103 20.9728 21.6103ZM23.8959 24.0717H18.1044V42.7826H23.8959V24.0717ZM36.7042 28.7511C34.3794 28.7511 33.1695 30.3138 33.1695 32.9499V42.7741H27.6091V24.0632H33.1695V26.5906C33.1695 26.5906 34.8417 23.4925 38.8114 23.4925C42.7812 23.4925 45.6226 25.9112 45.6226 30.9253V42.7741H39.8582V32.9499C39.8582 30.2594 38.8386 28.7511 36.7042 28.7511Z",
    fill: "#0F1936"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.9c4e6ad251bad84c2b34b1ad80298d47.svg";
export { ForwardRef as ReactComponent };